import { default as doesTableSupportUndo } from './util/doesTableSupportUndo';
import { LazyAction, LazyModule } from 'owa-bundling';
import { addActionToUndoStack, clearLastUndoableAction, hasUndoableAction, } from './actions/undoActions';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "UndoAction" */ './lazyIndex');
});
export var lazyUndo = new LazyAction(lazyModule, function (m) { return m.undo; });
export { addActionToUndoStack, clearLastUndoableAction, doesTableSupportUndo, hasUndoableAction };
//# sourceMappingURL=index.js.map